import { Spin, SpinProps } from "antd";
import { FC } from "react";

export type IncSpinProps = SpinProps;

export const IncSpin: FC<IncSpinProps> = (props) => <Spin {...props} />;
